<div class="alertbox error">
    <div class="icon">
        <img src="../../../../assets/img/icon/error.png" alt="Error" />
    </div>
    <h4>401</h4>
    <p>
        <b>{{
      'This transaction is not sustainable anymore. Please start a new payment process.'
        | translate
    }}</b>
    </p>
</div>
<div class="pButton">
    <button class="btn btn-primary" (click)="backToMerchant('fail')">
        {{ 'Back to Merchant' | translate }}
    </button>
</div>